import React from "react";

const HelpDesk = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              fill={fill}
            d="M16.4 32c0-1.289-1.074-2.333-2.4-2.333-1.325 0-2.4 1.044-2.4 2.333h-8c-.884 0-1.6-.697-1.6-1.556V5.556C2 4.696 2.716 4 3.6 4h8c0 1.289 1.075 2.333 2.4 2.333S16.4 5.29 16.4 4h16c.884 0 1.6.696 1.6 1.556v8.555c-2.21 0-4 1.741-4 3.889 0 2.148 1.79 3.889 4 3.889v8.555c0 .86-.716 1.556-1.6 1.556h-16ZM14 15.667c1.325 0 2.4-1.045 2.4-2.334C16.4 12.045 15.326 11 14 11c-1.325 0-2.4 1.045-2.4 2.333 0 1.289 1.075 2.334 2.4 2.334ZM14 25c1.325 0 2.4-1.045 2.4-2.333 0-1.29-1.074-2.334-2.4-2.334-1.325 0-2.4 1.045-2.4 2.334C11.6 23.955 12.675 25 14 25Z"
        />
    </svg>
);

export default HelpDesk;
